export const STATUS_COLORS: Record<string, string> = {
  INTERESTED: "#ef6c00",
  CALLBACK: "#ef6c00",
  OTHER: "#ef6c00",
  QUOTED: "#ef6c00",
  LEAFLET: "#ef6c00",
  OBSERVED_DIRTY: "#ef6c00",
  REGULAR: "#2e7d32",
  CUSTOMER: "#6a1b9a",
  NOT_INTERESTED: "#c62828",
  EXCLUDE_LOW_DEM: "#c62828",
  EXCLUDE_ACCESS: "#c62828",
};
